// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pointer[data-v-72dbd582]{cursor:pointer}.restore-infocard[data-v-72dbd582]{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:8px;line-height:32px;font-size:24px;font-weight:300}.restore-infocard a[data-v-72dbd582]{color:inherit}.restore-infocard i[data-v-72dbd582]{line-height:inherit}.infocard[data-v-72dbd582] a{color:inherit;font-weight:700}", ""]);
// Exports
module.exports = exports;
